/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import React from "react";
import DialogModal from "../DialogModal/DialogModal";
import { DialogProps } from "@mui/material/Dialog";

type TerminationDueDateModalProps = {
    open: boolean;
    onClose: () => void;
} & DialogProps;

const TerminationDueDateModal = ({ open, onClose, ...rest }: TerminationDueDateModalProps) => {
    return (
        <DialogModal open={open} onClose={onClose} {...rest} title={"3-Wochen-Frist"}>
            <p>
                Eine Abfindung kann nur 3 Wochen nach Erhalt der Kündigung geltend gemacht werden. Wenn Ihnen vor mehr als 3 Wochen gekündigt wurde, kann leider keine
                Kündigungsschutzklage eingereicht werden.
            </p>
        </DialogModal>
    );
};

export default TerminationDueDateModal;
